<template>
    <ai-grid-virtual-wrapper
        ref="gridVirtualRef"
        routed-view="view-kv-customer-new"
        :meta="meta"
        :custom-context-menu="customContextMenu"
        :set-context="setContext"
        @toolbar-button-click="toolbarButtonClick"
    />
</template>
<script setup>
import AiGridVirtualWrapper from '@/components/wrappers/ai-grid-virtual-wrapper.vue';
import {useRouter} from 'vue-router';
import {setTabTitle} from "@/layouts/main-layout/components/navigation-bars-data";
import {ref} from "vue";
import {ContextNames, getDefaultContextGroup, saveContexts} from "@/layouts/main-layout/main-layout-data";

const gridVirtualRef = ref();
const router = useRouter();
const columns = [
    {field: 'kodp', text: 'ID', visible: false},
    {field: 'nump', text: 'Номер', visible: true},
    {field: 'name', text: 'Наименование', width: 200},
    {field: 'allname', text: 'Полное наименование', width: 200},
    {field: 'inn', text: 'ИНН', width: 100},
    {field: 'kpp', text: 'КПП', width: 100},
    {field: 'okfs', text: 'Организационно-правовая форма', width: 200},
    {field: 'ministry_name', text: 'Министерство', width: 200},
    {field: 'ecls_name', text: 'Отношение к энергосистеме', width: 200},
    {field: 'okpo', text: 'ОКПО', width: 100},
    {field: 'ogrn', text: 'ОГРН', width: 100},
    {field: 'adr_ur', text: 'Юридический адрес', width: 200},
    {field: 'adr_fiz', text: 'Адрес местонахождения', width: 200},
    {field: 'adr_p', text: 'Адрес для переписки', width: 200},
    {field: 'es_id', text: 'Идентификатор внешней системы', width: 200},
    {field: 'ac_vers', text: 'Новая версия в ЕСК', width: 100},
];
const meta = {
    meta_args: {
        key: 'eobj_id',
        db_schema_name: 'payer',
        db_view_name: 'mvi_customer',
    },
    columns: columns,
    loadUrl: 'contragent./view-contragent-list/data/get',
    keyExpr: 'kodp',
    createViewRoutName: 'counteragent-card-view',
    toRemoveToolbarItemsNames: ['choice', 'copy', 'save'],
    viewId: 'view-kv-customer-new'
};

const customContextMenu = [
    {
        text: 'Открыть карточку контрагента',
        onItemClick: async e => {
            setTabTitle(`${e.itemData.rowData.data['name']}`);
            await router.push({name: 'counteragent-card-view', params: {id: e.itemData.rowData.key}});
        },
    },
];
const setContext = async (dataRow) => {
    const orgContextGroup = getDefaultContextGroup(ContextNames.ORG_CONTEXT_GROUP);
    orgContextGroup.contexts.PayerContext = {value: dataRow['kodp'], userText: dataRow['name']};
    await saveContexts({nameGroup: ContextNames.ORG_CONTEXT_GROUP, value: orgContextGroup});
};

const toolbarButtonClick = async e => {
    if (e.item.component.name === 'edit') {
        const key = gridVirtualRef.value.gridInstance.gridInstance.option('focusedRowKey');
        const rowData = gridVirtualRef.value.gridInstance.gridInstance.option('dataSource').items().find(row => row[meta.keyExpr] === key);
        setTabTitle(`${rowData['name']}`);
        await router.push({name: 'counteragent-card-view', params: {id: key}});
    }
};
</script>
<script>
export default {name: 'view-kv-customer-new'}
</script>
